import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
import { CATALOG } from "@/game/appurtenances";

/**
 * Grafton 91 ft monopole — real pole at 43 Estabrook St, Grafton MA (Crown Castle
 * BU 842903 / DISH), from reference_towers/02_engineering_drawings/
 * MA_Grafton_monopole_91ft_structural.pdf (tnxTower SA).
 *   - 18-sided tapered tube, 2 sections, 91.5 ft (27.89 m).
 *   - Base OD 42.875" (1.089 m), tip OD 19.396" (0.493 m); wall 0.188"→0.25".
 *   - TIA-222-H, Risk II, 126 mph, Exp C. DISH at 59 ft; existing carriers 69–90 ft.
 * Grade not tabulated → A572-65 typical. Foundation page not read → competent pier.
 */
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
const AZ = [0, (2 * Math.PI) / 3, (4 * Math.PI) / 3];

export const design: TowerDesign = {
  id: "monopole-grafton-91ft",
  name: "Monopole (Grafton 91 ft)",
  description: "Real 91 ft monopole, Grafton MA (Crown Castle BU 842903 / DISH).",
  author: "reference: MA Grafton 91 ft tnxTower SA",
  spec: {
    type: "monopole",
    height: 27.89,
    stack: {
      faces: 12, panels: 8,
      baseRadius: 0.545, topRadius: 0.25,
      legSection: "legXL", braceSection: "braceHeavy",
      legMaterial: A572_65, braceMaterial: A572_65, bracing: "X",
    },
    shell: { baseDiameter: 1.089, topDiameter: 0.493 },
    foundation: {
      soil: "dense-sand",
      base: { type: "pier", width: 2.1, diameter: 2.1, depth: 5.5, concrete: "c30" },
      connection: {
        kind: "anchorBolts", nBolts: 12, bolt: "b1_5", grade: "f1554_55",
        boltCircleDia: 1.0, embedment: 0.4, edgeDistance: 0.25,
        platePlanArea: 1.3, plateThickness: 0.045, plateGrade: "a36rod", fc: 30e6,
      },
    },
    loads: [
      ...AZ.flatMap((azimuth) => [
        { appurtenance: CATALOG.panelSector, height: 18.0, azimuth },
        { appurtenance: CATALOG.rru, height: 18.0, azimuth },
      ]),
      ...AZ.map((azimuth) => ({ appurtenance: CATALOG.panelSector, height: 26.0, azimuth })),
      { appurtenance: CATALOG.coaxBundle, height: 26.0, runLength: 26.0 },
    ],
  },
};
